import { Vue, Component, Prop } from "vue-property-decorator";
import { Icon, Button } from "ant-design-vue";
import ExpandIcon from "@/style/svgs/expand.svg";
import { ObjectiveModule } from "@/modules/objective";
import { fmtMsg } from "commonui";
import { VcsLocale } from "@/locales/localeid";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";

@Component({
	components: {
		Icon,
		Button
	}
})
export default class ExpandCollapse extends Vue {
	get expandIcon() {
		return ExpandIcon;
	}
	get initClass() {
		return ObjectiveModule.isLevel3Selected ? "init-selected" : "";
	}
	get expandLevel() {
		return fmtMsg(VcsLocale.ObjectiveExpandLevel);
	}
	get addNewObjectiveCategory() {
		return fmtMsg(VcsLocale.ObjectiveAddNewObjectiveCategory);
	}
	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}
	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}
	onChange(value: any): void {
		ObjectiveModule.setLevel3Selected(false);
		this.$emit("action", value);
	}
}
